"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLength = exports.isEmpty = exports.isEmail = exports.isContainWhiteSpace = exports.getValidators = exports.capitalizeStr = exports.applyValidators = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var applyValidators = function applyValidators(value, validators, key, form) {
  var errorMsg = "";
  for (var i = 0; i < validators.length; i++) {
    // check required validator

    if (validators[i]["name"] === "required" && validators[i]["value"] == true) {
      if (isEmpty(value) || (value === null || value === void 0 ? void 0 : value.length) == 0) {
        errorMsg = validators[i].hasOwnProperty('validationMessage') ? validators[i]["validationMessage"] : capitalizeStr(key) + " is required.";
        break;
      }
    }

    // check minLength validator
    if (validators[i]["name"] === "minLength") {
      if (value && value.length < validators[i]["value"]) {
        errorMsg = validators[i].hasOwnProperty('validationMessage') ? validators[i]["validationMessage"] : "Min length for " + capitalizeStr(key) + " is " + validators[i]["value"] + ".";
        break;
      }
    }

    // check minLength validator
    if (validators[i]["name"] === "maxLength") {
      if (value && value.length > validators[i]["value"]) {
        errorMsg = validators[i].hasOwnProperty('validationMessage') ? validators[i]["validationMessage"] : "Max length for " + capitalizeStr(key) + " is " + validators[i]["value"] + ".";
        break;
      }
    }

    // check minLength validator
    if (validators[i]["name"] === "isEmail") {
      if (!isEmail(value)) {
        errorMsg = validators[i].hasOwnProperty('validationMessage') ? validators[i]["validationMessage"] : "Please Enter a valid email.";
        break;
      }
    }

    if (validators[i]["name"] === "isPassword") {
      if (!isPassword(value)) {
        errorMsg = validators[i].hasOwnProperty('validationMessage') ? validators[i]["validationMessage"] : "Password must be at least 8 characters long and contain at least one number.";
        break;
      }
    }

    // check minLength validator
    if (validators[i]["name"] === "matchFields") {
      var matchfieldsValue = "";
      if (form && form.hasOwnProperty(validators[i]["value"])) matchfieldsValue = form[validators[i]["value"]];
      if (value !== matchfieldsValue) {
        errorMsg = validators[i].hasOwnProperty('validationMessage') ? validators[i]["validationMessage"] : validators[i]["value"] + " and " + key + " did not match.";
        break;
      }
    }
  }
  return errorMsg;
};

/**
 * Chek if email is valid
 * @prop String email
 * @returns Boolean
 */
exports.applyValidators = applyValidators;
var isEmail = function isEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
exports.isEmail = isEmail;

/**
 * Chek if password is valid
 * @prop String password
 * @returns Boolean
 */
var isPassword = function isPassword(password) {
  var re = /^(?=.*\d).{8,}$/;
  return re.test(String(password));
};
exports.isPassword = isPassword;

var capitalizeStr = function capitalizeStr(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Chek if vatiable is empty
 * @prop String thing
 * @returns Boolean
 */
exports.capitalizeStr = capitalizeStr;
var isEmpty = function isEmpty(thing) {
  var empty = false;
  switch (_typeof(thing)) {
    case "undefined":
      empty = true;
      break;
    case "string":
      if (thing.trim().length === 0) {
        empty = true;
      }
      break;
    case "object":
      if (thing === null) {
        empty = true;
      } else if (Object.keys(thing).length === 0) {
        empty = true;
      }
      break;
    default:
      empty = true;
  }
  return empty;
};

/**
 * Check length of the string greater than
 * @prop String|Integer str
 * @prop boolean|options.trim Trim input before validating
 * @prop number|options.lt Check if length less than lt
 * @prop number|options.lte Check if length is less than or equals to lte
 * @prop number|options.gt Check if length is greater than gt
 * @prop number|options.gte Check if length is greater than or equals to gte
 * @returns Boolean
 */
exports.isEmpty = isEmpty;
var isLength = function isLength(str, options) {
  if (isEmpty(options)) {
    throw new Error("Who will provide the options you?");
  }
  var isValid = true;
  if (["string", "number"].indexOf(_typeof(str)) === -1) {
    isValid = false;
  } else {
    // Convert to string incase it's number
    var len = 0;
    if (options.trim) {
      len = str.toString().trim().length;
    } else {
      len = str.toString().length;
    }
    if (typeof options.lt === "number" && len >= options.lt) {
      isValid = false;
    } else if (typeof options.lte === "number" && len > options.lte) {
      isValid = false;
    } else if (typeof options.gt === "number" && len <= options.gt) {
      isValid = false;
    } else if (typeof options.gte === "number" && len < options.gte) {
      isValid = false;
    }
  }
  return isValid;
};

/**
 * Check if string contains whitespaces
 * @prop String str
 * @returns Boolean
 */
exports.isLength = isLength;
var isContainWhiteSpace = function isContainWhiteSpace(str) {
  if (typeof str === "string" || typeof str === "number") {
    return str.toString().trim().indexOf(" ") !== -1;
  } else {
    return false;
  }
};
exports.isContainWhiteSpace = isContainWhiteSpace;
var getValidators = function getValidators(fieldObject, key) {
  var validators = [];
  if (fieldObject.hasOwnProperty('validators')) {
    validators = fieldObject.validators;
  }
  return validators;
};
exports.getValidators = getValidators;